var _ellipse, _ellipse2, _mask, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotorSolutionFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7,
    cy: 6.5,
    rx: 7,
    ry: 3.5,
    fill: "#ED3431"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.99996,
    cy: 6,
    rx: 4.84615,
    ry: 2,
    fill: "#8E1F1D"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 10,
    height: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.99996,
    cy: 6,
    rx: 4.84615,
    ry: 2,
    fill: "#5F1514"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.99996,
    cy: 8,
    rx: 4.84615,
    ry: 2,
    fill: "#5F1514"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8466 3V6C11.8466 7.10457 9.67691 8 7.00045 8C4.32399 8 2.1543 7.10457 2.1543 6V3C2.1543 1.89543 4.32399 1 7.00045 1C9.67691 1 11.8466 1.89543 11.8466 3Z",
    fill: "#E5ECF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6967 3.49521C11.1628 4.36025 9.26252 5 7.00023 5C4.73793 5 2.8377 4.36025 2.30377 3.49521C2.25485 3.49837 2.20487 3.5 2.15407 3.5C1.5593 3.5 1.07715 3.27614 1.07715 3C1.07715 2.72386 1.5593 2.5 2.15407 2.5C2.20487 2.5 2.25485 2.50163 2.30377 2.50479C2.8377 1.63975 4.73793 1 7.00023 1C9.26252 1 11.1628 1.63975 11.6967 2.50479C11.7456 2.50163 11.7956 2.5 11.8464 2.5C12.4411 2.5 12.9233 2.72386 12.9233 3C12.9233 3.27614 12.4411 3.5 11.8464 3.5C11.7956 3.5 11.7456 3.49837 11.6967 3.49521Z",
    fill: "#99B2C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotorSolutionFront);
export default __webpack_public_path__ + "static/media/rotor-solution-front.6d703767d970023c6c56e86fb4133ecb.svg";
export { ForwardRef as ReactComponent };